export * from '@sentry/browser';
export { init } from './sdk';
export { vueRouterInstrumentation } from './vuerouter';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/vue/esm/index.js
// module id = 271
// module chunks = 1